import { onUnmounted } from '@/lib/vue-composition-api.js';

export default function useActiveImageByMouse(container, images, activeImageIndex) {
    const calcActiveImage = (event) => {
        const rect = container.getBoundingClientRect();
        const containerWidth = rect.width;
        const mouseX = event.clientX - rect.left;
        const sectorWidth = containerWidth / images.length;

        let imgIndex = Math.floor(mouseX / sectorWidth);

        if (imgIndex < 0) {
            imgIndex = 0;
        } else if (imgIndex > images.length - 1) {
            imgIndex = images.length - 1;
        }

        activeImageIndex.value = imgIndex;
    };

    const resetActiveImage = () => {
        activeImageIndex.value = 0;
    };

    onUnmounted(() => {
        container.removeEventListener('mousemove', calcActiveImage);
        container.removeEventListener('mouseleave', resetActiveImage);
    });

    container.addEventListener('mousemove', calcActiveImage);
    container.addEventListener('mouseleave', resetActiveImage);
}
